/* eslint-disable react/sort-comp,import/prefer-default-export */
/* @flow */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import type { Connector } from 'react-redux';
import './styles.scss';
import Title from '../../../../../../components/Title/index';
import SubTitle from '../../../../../../components/SubTitle/index';
import Paragraph from '../../../../../../components/Paragraph/index';
import Button from '../../../../../../components/Button/index';
import {
  QuestionnaireExperience as QuestionnaireExperienceContext,
  Reducer,
} from '../../../../../../types/index';

type Props = {
  history: Object,
  questionnaireContext: QuestionnaireExperienceContext,
  handleRedirect: () => void,
};

// Export this for unit testing more easily
export class Instructions extends PureComponent {
  props: Props;

  static defaultProps: {
    history: {},
  };

  render() {
    const { questionnaireContext } = this.props;

    const CONTRARY_HEREIN_OR_IN_THE_PARTNERSHIP =`NOTWITHSTANDING ANYTHING TO THE CONTRARY HEREIN OR IN THE PARTNERSHIP
        AGREEMENT, NOTHING HEREIN OR THEREIN SHALL BE CONSTRUED AS A WAIVER OF ANY
        PERSON’S NON-WAIVABLE, FEDERAL FIDUCIARY DUTIES TO THE PARTNERSHIP UNDER THE
        U.S. INVESTMENT ADVISERS ACT OF 1940, AS AMENDED (TOGETHER, WITH THE RULES AND
        REGULATIONS PROMULGATED THEREUNDER, THE “ADVISERS ACT”). NOTHING HEREIN OR
        IN THE PARTNERSHIP AGREEMENT SHALL BE CONSTRUED TO (I) PROHIBIT ANY PERSON
        FROM REPORTING POSSIBLE VIOLATIONS OF APPLICABLE LAW OR REGULATION TO ANY
        GOVERNMENTAL AGENCY OR ENTITY, OR MAKING OTHER DISCLOSURES THAT ARE
        PROTECTED UNDER THE WHISTLEBLOWER PROVISIONS OF APPLICABLE LAW OR
        REGULATION OR (II) REQUIRE ANY SUCH PERSON TO PROVIDE NOTIFICATION THAT IT HAS
        MADE SUCH REPORTS OR DISCLOSURES.`;
    return (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="content-bg main-content-area clearfix">
            <div className="row instructions-container">
              <Title text={questionnaireContext.fund.fundLegalName} />
              <Title text={'Signature Package'} />
              <br />
              <SubTitle isLink={false} text={'INSTRUCTIONS'} underline />
                <div>
                 <b>
                  <p>
                    Welcome to the electronic investor questionnaire for Accel Circle Fund 2026 L.P. (the “Fund”). 
                    You must carefully complete this investor questionnaire by completing the General Information 
                    required under Part 1, checking the appropriate boxes in the questionnaire in Part 2, and executing this questionnaire.
                  </p>
                  <p>
                    Once you are finished, this electronic investor questionnaire has been integrated with DocuSign, which will 
                    allow you to designate a signatory to receive and sign the documents electronically. We will automatically 
                    receive the executed documents from DocuSign. You may also download the unsigned questionnaire 
                    from DocuSign for review or manual signature.
                  </p>
                  <p>
                    You may also need to provide additional “know your client” information to the fund’s compliance agent. 
                    Accel and Alter Domus will contact you directly to set out what information will be required and to 
                    undertake the collection and review of this information. If you have any questions, please do not 
                    hesitate to contact Alter Domus at {' '} <a href={`mailto:AccelKYC@AlterDomus.com`}> 
                    AccelKYC@AlterDomus.com</a>.
                  </p>
                </b>
             </div>
              <br />
              <SubTitle isLink={false} text={'GENERAL NOTICE'} underline />
              <div className="paragraph-container">
                  <p>
                    THE LIMITED PARTNERSHIP INTERESTS REFERRED TO IN THIS INVESTOR QUESTIONNAIRE (THE “SECURITIES”) HAVE NOT BEEN REGISTERED 
                    UNDER THE UNITED STATES SECURITIES ACT OF 1933, AS AMENDED (TOGETHER, WITH THE RULES AND REGULATIONS
                    PROMULGATED THEREUNDER, THE “SECURITIES ACT”) OR THE SECURITIES LAWS OF ANY OTHER STATE OR JURISDICTION. THE SECURITIES MAY 
                    NOT BE SOLD, OFFERED FOR SALE, PLEDGED OR HYPOTHECATED IN THE ABSENCE OF A REGISTRATION STATEMENT IN EFFECT WITH RESPECT TO 
                    SUCH INTERESTS UNDER THE SECURITIES ACT OR AN EXEMPTION THEREFROM. 
                    <br />
                    <br />
                    INVESTORS SHOULD BE AWARE THAT THEY WILL BE REQUIRED TO BEAR 
                    THE FINANCIAL RISKS OF THIS INVESTMENT FOR AN INDEFINITE PERIOD OF TIME. IN MAKING AN INVESTMENT DECISION, INVESTORS MUST RELY 
                    ON THEIR OWN EXAMINATION OF THE FUND AND THE TERMS OF THE OFFERING, INCLUDING THE MERITS AND RISKS INVOLVED. INVESTORS ARE ENCOURAGED 
                    TO SEEK INDEPENDENT LEGAL, INVESTMENT AND TAX ADVICE REGARDING INDIVIDUAL CIRCUMSTANCES AND FINANCIAL OBJECTIVES IN DETERMINING WHETHER
                    TO INVEST IN THE FUND. 
                    <br /><br />
                    THE SECURITIES HAVE NOT BEEN APPROVED OR DISAPPROVED BY ANY FEDERAL OR STATE SECURITIES COMMISSION OR 
                    REGULATORY AUTHORITY NOR HAVE THE FOREGOING AUTHORITIES PASSED UPON THE ACCURACY OR ADEQUACY OF THE OFFERING MATERIALS. ANY REPRESENTATION 
                    TO THE CONTRARY IS A CRIMINAL OFFENSE.
                  </p>
              </div>
              <br />
              <Paragraph text={CONTRARY_HEREIN_OR_IN_THE_PARTNERSHIP} />
            </div>
          </div>
          <br />
          <div className="next-btn">
            <Button
              inputData={{ id: 'next-btn', displayName: 'Next', type: 'button' }}
              clickHandler={event =>
                this.props.handleRedirect(event, questionnaireContext.currentStep + 1)
              }
            />
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: Reducer) => ({
  questionnaireContext: state.questionnaireExperience,
});
const connector: Connector<{}, Props> = connect(
  mapStateToProps,
  null,
);

export default connector(Instructions);
